import React from "react";
import { Link } from "react-router-dom";

const shopPoints = [
  "فروش آنلاین، پرداخت و ارسال در یک سیستم",
  "پنل مدیریت کامل فروشگاه و سفارش‌ها",
  "پرداخت اقساطی اسنپ‌پی و دیجی‌پی",
  "فروش خرده، عمده و سازمانی",
];

const coresellPoints = [
  "سینک ثانیه‌ای با دیجی‌کالا، باسلام و سایت شخصی",
  "قیمت‌گذاری خودکار بر اساس درصد کمیسیون هر درگاه",
  "انبارگردانی دسته‌ای و به‌روزرسانی با اکسل",
  "صفر کردن جریمه‌های لغو سفارش و پیشگیری از ناموجودی",
];

const ShopPromo = () => {
  return (
    <section className="py-14 sm:py-18 bg-slate-800/40 border-y border-slate-700/50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10">
          <p className="text-teal-400 text-sm font-semibold mb-2 tracking-wide">
            محصولات و سیستم‌های اختصاصی استودیو آلتو
          </p>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white">
            پلتفرم‌های نرم‌افزاری توسعه‌یافته در آلتو
          </h2>
          <p className="text-slate-400 text-sm sm:text-base mt-2 max-w-xl mx-auto">
            سامانه‌های اختصاصی ما با جدیدترین متدهای مهندسی نرم‌افزار، آماده یکپارچه‌سازی و رشد کسب‌وکار شما هستند.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">
          {/* Shop System Card */}
          <div className="bg-slate-800/90 rounded-2xl border border-teal-500/25 p-6 sm:p-8 flex flex-col justify-between hover:border-teal-500/50 hover:shadow-2xl hover:shadow-teal-500/10 transition-all duration-300 group">
            <div>
              <div className="flex items-center justify-between mb-4">
                <span className="inline-flex items-center gap-1.5 text-xs font-bold text-teal-300 bg-teal-500/15 border border-teal-500/30 px-3 py-1 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-teal-400"></span>
                  محصول اختصاصی آلتو
                </span>
                <span className="text-xs text-slate-400 font-mono">Next.js eCommerce</span>
              </div>

              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 group-hover:text-teal-400 transition-colors">
                سیستم فروشگاه آنلاین
              </h3>
              <p className="text-slate-400 text-sm sm:text-base leading-relaxed mb-6">
                از ثبت محصول تا پرداخت، ارسال و بازاریابی — یک پلتفرم یکپارچه، فوق‌سریع و سئو شده برای راه‌اندازی و مدیریت فروشگاه‌های اینترنتی نسل جدید.
              </p>

              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-8">
                {shopPoints.map((point, i) => (
                  <li key={i} className="flex items-start gap-2 text-slate-300 text-xs sm:text-sm">
                    <svg className="w-4 h-4 text-teal-400 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 pt-5 border-t border-slate-700/60">
              <Link
                to="/shop"
                className="w-full sm:flex-1 inline-flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-500 text-white font-medium px-5 py-3 rounded-xl text-sm transition-all shadow-md shadow-teal-600/20"
              >
                مشاهده امکانات فروشگاه
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </Link>
              <a
                href="https://wa.me/09134378347"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 text-slate-300 hover:text-white hover:bg-slate-700/50 border border-slate-600 px-5 py-3 rounded-xl text-sm font-medium transition-colors"
              >
                درخواست دمو
              </a>
            </div>
          </div>

          {/* CoreSell System Card */}
          <div className="bg-slate-800/90 rounded-2xl border border-cyan-500/35 p-6 sm:p-8 flex flex-col justify-between hover:border-cyan-500/60 hover:shadow-2xl hover:shadow-cyan-500/15 transition-all duration-300 relative overflow-hidden group">
            <div className="absolute top-0 left-0 w-32 h-32 bg-cyan-500/5 rounded-full blur-2xl pointer-events-none -z-0" />
            
            <div className="relative z-10">
              <div className="flex items-center justify-between mb-4">
                <span className="inline-flex items-center gap-1.5 text-xs font-bold text-cyan-300 bg-cyan-500/15 border border-cyan-500/30 px-3 py-1 rounded-full">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-400"></span>
                  </span>
                  حاصل ۷ ماه مهندسی
                </span>
                <span className="text-xs text-cyan-400 font-mono font-bold tracking-wider">CORESELL</span>
              </div>

              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 group-hover:text-cyan-300 transition-colors flex items-center justify-between">
                <span>سامانه مدیریت موجودی و قیمت کورسل</span>
              </h3>
              <p className="text-slate-400 text-sm sm:text-base leading-relaxed mb-6">
                موتور هوشمند همگام‌سازی لحظه‌ای موجودی و قیمت چندکاناله؛ سینک ثانیه‌ای انبار مرکزی، ووکامرس، دیجی‌کالا و باسلام بر پایه صف‌های توزیع‌شده BullMQ.
              </p>

              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-8">
                {coresellPoints.map((point, i) => (
                  <li key={i} className="flex items-start gap-2 text-slate-300 text-xs sm:text-sm">
                    <svg className="w-4 h-4 text-cyan-400 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="relative z-10 flex flex-col sm:flex-row items-center gap-3 pt-5 border-t border-slate-700/60">
              <Link
                to="/coresell"
                className="w-full sm:flex-1 inline-flex items-center justify-center gap-2 bg-gradient-to-r from-teal-500 to-cyan-500 hover:from-teal-400 hover:to-cyan-400 text-slate-950 font-bold px-5 py-3 rounded-xl text-sm transition-all shadow-md shadow-cyan-500/20"
              >
                مشاهده صفحه اختصاصی کورسل
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </Link>
              <a
                href="https://wa.me/09134378347"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 text-slate-300 hover:text-white hover:bg-slate-700/50 border border-slate-600 px-5 py-3 rounded-xl text-sm font-medium transition-colors"
              >
                استعلام و اتصال
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopPromo;
